import React, { useMemo } from 'react';
import { parseTvConfig } from '../../../../utils/tvConfig';
import { TvPlayer } from './TvPlayer';
import './TvSlideshow.css';

export const TvSlideshow: React.FC = () => {
  const parsedTvConfig = useMemo(() => parseTvConfig(window.location.search), []);

  if (!parsedTvConfig.ok) {
    return (
      <div className="tv-slideshow tv-slideshow--message">
        <div>
          <p>Invalid TV settings.</p>
          <ul className="tv-slideshow__error-list">
            {parsedTvConfig.errors.map((error) => <li key={error}>{error}</li>)}
          </ul>
        </div>
      </div>
    );
  }

  return <TvPlayer config={parsedTvConfig.config} />;
};
